'use client';

import React from 'react';
import { ClockBackground } from './ClockBackground';
import { CityClocks } from './CityClocks';
import { useDragTime } from '@hooks/useDragTime';

export const TW_CLOCK_SIZE = `
  aspect-square
  w-full
  max-w-[min(46vw,46vh)]
  sm:max-w-[min(55vw,55vh)]
  landscape:max-w-[min(40vw,58vh)]
  landscape:md:max-w-[min(48vw,48vh)]
  lg:max-w-[min(40vw,calc(100vh-260px))]
`

interface ClockProps {
  ClockBackgroundComponent?: React.ReactNode;
}

const Clock: React.FC<ClockProps> = ({ ClockBackgroundComponent }) => {
  const { isDragging, eventHandlers } = useDragTime();

  return (
    <div className="w-full flex justify-center my-12 landscape:my-0 px-8">
      <div className={`relative ${TW_CLOCK_SIZE}`} style={{ touchAction: 'none', containerType: 'inline-size' }}>
        <div
          id="clock-container"
          className="absolute inset-0 cursor-grab"
          onMouseDown={eventHandlers.onMouseDown}
          onTouchStart={eventHandlers.onTouchStart}
          style={{
            cursor: isDragging ? 'grabbing' : 'grab',
            touchAction: 'none'
          }}
        >
          {ClockBackgroundComponent || (
            <div className="absolute inset-0 shadow-soft">
              <ClockBackground />
            </div>
          )}
        </div>
        <div className="absolute inset-0">
          <CityClocks />
        </div>
      </div>
    </div>
  );
};

export default Clock;
